export const shouldUseMerchantHasuraFeed = ({
    isLocalDashboardEnvironment,
    localHasuraFallbackEnabled,
    storeIds,
}) => {
    if (!Array.isArray(storeIds) || storeIds.length === 0) {
        return false;
    }

    return !isLocalDashboardEnvironment || localHasuraFallbackEnabled;
};

export const buildMerchantStoreShipmentWhereClause = () =>
    'where: { Orders: { store_id: {_in: $storeIds} } }';